<section class="card" *ngIf="s" aria-label="Heatmap controls">
  <header class="head">
    <div>
      <h3>{{ title }}</h3>
      <p class="asof" *ngIf="s.data.generated">as of {{ s.data.generated }}</p>
    </div>
    <span class="spinner" *ngIf="loading" role="status" aria-label="Loading"></span>
    <button *ngIf="hasConditions" type="button" class="conditions-btn" (click)="showConditions = true">
      Conditions
    </button>
  </header>

  <ng-container *ngIf="windows.length">
    <div class="label">Timeframe</div>
    <div class="segmented" role="group" aria-label="Timeframe">
      <button *ngFor="let w of windows" type="button" [class.on]="s.window === w" [disabled]="loading"
        (click)="heat.setWindow(w)">{{ windowLabel(w) }}</button>
    </div>
  </ng-container>

  <div class="label">Species</div>
  <div class="pills">
    <button *ngFor="let o of topRow" type="button" class="pill" [class.on]="s.species === o.key"
      [disabled]="loading" (click)="heat.setSpecies(o.key)">{{ chipLabel(o) }}</button>
  </div>
  <ng-container *ngFor="let g of groups">
    <div class="label">{{ g.label }}</div>
    <div class="pills">
      <button *ngFor="let o of g.rows" type="button" class="pill" [class.on]="s.species === o.key"
        [disabled]="loading" (click)="heat.setSpecies(o.key)">{{ chipLabel(o) }}</button>
    </div>
  </ng-container>

  <p class="status muted" *ngIf="s.status === 'empty'">No catch data for this timeframe or species yet.</p>
  <p class="status error" *ngIf="s.status === 'error'">
    Couldn't load catch heat.
    <button type="button" class="retry" (click)="heat.retry()">Retry</button>
  </p>
</section>

<!-- Conditions: the backend-composed analysis, rendered verbatim -->
<div class="scrim" *ngIf="showConditions" (click)="showConditions = false">
  <div class="sheet" role="dialog" aria-label="Conditions" (click)="$event.stopPropagation()">
    <header class="sheet-head">
      <div>
        <h2>Conditions</h2>
        <p class="asof" *ngIf="s.data.generated">as of {{ s.data.generated }}</p>
      </div>
      <button type="button" class="close" aria-label="Close" (click)="showConditions = false">✕</button>
    </header>
    <div class="sheet-body">
      <ng-container *ngIf="paragraphs.length; else stitched">
        <p *ngFor="let p of paragraphs" class="para">{{ p }}</p>
      </ng-container>
      <ng-template #stitched>
        <p class="para" *ngIf="s.data.regionalSummary">{{ s.data.regionalSummary }}</p>
        <ng-container *ngIf="sections.length">
          <h4 class="spots">Hot spots</h4>
          <div class="spot" *ngFor="let sp of sections">
            <div class="chips">
              <span class="chip band-rank" *ngIf="sp.rank != null">#{{ sp.rank }}</span>
              <span class="chip" *ngIf="sp.band" [ngClass]="bandClass(sp.band)">{{ sp.band }}</span>
            </div>
            <p class="para" [class.primary]="sp.isPrimary">{{ sp.summary }}</p>
          </div>
        </ng-container>
      </ng-template>
    </div>
  </div>
</div>
